<button
    class="radio-button"
    type="button"
    [class.radio-button--checked]="checked()"
    [disabled]="disabled()"
    (click)="onRadioClick($event)">
    <div class="radio-button__inner"></div>
</button>
